import { buildCriterionExpression, buildRelevanceSortCriterion, } from './criteria.js';
export function getSortCriteriaInitialState() {
    return buildCriterionExpression(buildRelevanceSortCriterion());
}
